import { render, staticRenderFns } from "./lower-list.vue?vue&type=template&id=1b9681d4&scoped=true&"
import script from "./lower-list.vue?vue&type=script&lang=js&"
export * from "./lower-list.vue?vue&type=script&lang=js&"
import style0 from "./lower-list.vue?vue&type=style&index=0&id=1b9681d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9681d4",
  null
  
)

export default component.exports